function cookieTermsInit() {
    $('#isa-cookies-dismiss-btn').on('click', function () {
        // set cookie
        var siteDomain = $('#hdn-current-domain').val();
        if(!$.cookie('cookie-policy')) {
            console.log('inside cookies');
            $.cookie('cookie-policy', 1, { expires: 365, domain: siteDomain, path: '/' });
        }
        $('#isa-cookies-msg').hide();
    });
}

$(function () {
    cookieTermsInit();
});
